"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageTypes = exports.ImageTypes = exports.PkpassNumberStyleTypes = exports.PkpassDateStyleTypes = exports.PkpassTextAlignTypes = exports.PkpassDataDetectorTypes = exports.PkpassTransitTypes = exports.PkpassFieldsType = exports.PkpassBarcodeTypes = exports.passStyles = exports.PkpassPassStyleTypes = void 0;
var PkpassPassStyleTypes;
exports.PkpassPassStyleTypes = PkpassPassStyleTypes;

(function (PkpassPassStyleTypes) {
  PkpassPassStyleTypes["Coupon"] = "coupon";
  PkpassPassStyleTypes["BoardingPass"] = "boardingPass";
  PkpassPassStyleTypes["EventTicket"] = "eventTicket";
  PkpassPassStyleTypes["Generic"] = "generic";
  PkpassPassStyleTypes["StoreCard"] = "storeCard";
})(PkpassPassStyleTypes || (exports.PkpassPassStyleTypes = PkpassPassStyleTypes = {}));

var passStyles = [PkpassPassStyleTypes.BoardingPass, PkpassPassStyleTypes.Coupon, PkpassPassStyleTypes.EventTicket, PkpassPassStyleTypes.Generic, PkpassPassStyleTypes.StoreCard];
exports.passStyles = passStyles;
var PkpassBarcodeTypes;
exports.PkpassBarcodeTypes = PkpassBarcodeTypes;

(function (PkpassBarcodeTypes) {
  PkpassBarcodeTypes["PKBarcodeFormatAztec"] = "PKBarcodeFormatAztec";
  PkpassBarcodeTypes["PKBarcodeFormatCode128"] = "PKBarcodeFormatCode128";
  PkpassBarcodeTypes["PKBarcodeFormatPDF417"] = "PKBarcodeFormatPDF417";
  PkpassBarcodeTypes["PKBarcodeFormatQR"] = "PKBarcodeFormatQR";
})(PkpassBarcodeTypes || (exports.PkpassBarcodeTypes = PkpassBarcodeTypes = {}));

var PkpassFieldsType;
exports.PkpassFieldsType = PkpassFieldsType;

(function (PkpassFieldsType) {
  PkpassFieldsType["AuxiliaryFields"] = "auxiliaryFields";
  PkpassFieldsType["BackFields"] = "backFields";
  PkpassFieldsType["HeaderFields"] = "headerFields";
  PkpassFieldsType["PrimaryFields"] = "primaryFields";
  PkpassFieldsType["SecondaryFields"] = "secondaryFields";
})(PkpassFieldsType || (exports.PkpassFieldsType = PkpassFieldsType = {}));

var PkpassTransitTypes;
exports.PkpassTransitTypes = PkpassTransitTypes;

(function (PkpassTransitTypes) {
  PkpassTransitTypes["PKTransitTypeAir"] = "PKTransitTypeAir";
  PkpassTransitTypes["PKTransitTypeBoat"] = "PKTransitTypeBoat";
  PkpassTransitTypes["PKTransitTypeBus"] = "PKTransitTypeBus";
  PkpassTransitTypes["PKTransitTypeGeneric"] = "PKTransitTypeGeneric";
  PkpassTransitTypes["PKTransitTypeTrain"] = "PKTransitTypeTrain";
})(PkpassTransitTypes || (exports.PkpassTransitTypes = PkpassTransitTypes = {}));

var PkpassDataDetectorTypes;
exports.PkpassDataDetectorTypes = PkpassDataDetectorTypes;

(function (PkpassDataDetectorTypes) {
  PkpassDataDetectorTypes["PKDataDetectorTypePhoneNumber"] = "PKDataDetectorTypePhoneNumber";
  PkpassDataDetectorTypes["PKDataDetectorTypeLink"] = "PKDataDetectorTypeLink";
  PkpassDataDetectorTypes["PKDataDetectorTypeAddress"] = "PKDataDetectorTypeAddress";
  PkpassDataDetectorTypes["PKDataDetectorTypeCalendarEvent"] = "PKDataDetectorTypeCalendarEvent";
})(PkpassDataDetectorTypes || (exports.PkpassDataDetectorTypes = PkpassDataDetectorTypes = {}));

var PkpassTextAlignTypes;
exports.PkpassTextAlignTypes = PkpassTextAlignTypes;

(function (PkpassTextAlignTypes) {
  PkpassTextAlignTypes["PKTextAlignmentLeft"] = "PKTextAlignmentLeft";
  PkpassTextAlignTypes["PKTextAlignmentCenter"] = "PKTextAlignmentCenter";
  PkpassTextAlignTypes["PKTextAlignmentRight"] = "PKTextAlignmentRight";
  PkpassTextAlignTypes["PKTextAlignmentNatural"] = "PKTextAlignmentNatural";
})(PkpassTextAlignTypes || (exports.PkpassTextAlignTypes = PkpassTextAlignTypes = {}));

var PkpassDateStyleTypes;
exports.PkpassDateStyleTypes = PkpassDateStyleTypes;

(function (PkpassDateStyleTypes) {
  PkpassDateStyleTypes["PKDateStyleNone"] = "PKDateStyleNone";
  PkpassDateStyleTypes["PKDateStyleShort"] = "PKDateStyleShort";
  PkpassDateStyleTypes["PKDateStyleMedium"] = "PKDateStyleMedium";
  PkpassDateStyleTypes["PKDateStyleLong"] = "PKDateStyleLong";
  PkpassDateStyleTypes["PKDateStyleFull"] = "PKDateStyleFull";
})(PkpassDateStyleTypes || (exports.PkpassDateStyleTypes = PkpassDateStyleTypes = {}));

var PkpassNumberStyleTypes;
exports.PkpassNumberStyleTypes = PkpassNumberStyleTypes;

(function (PkpassNumberStyleTypes) {
  PkpassNumberStyleTypes["PKNumberStyleDecimal"] = "PKNumberStyleDecimal";
  PkpassNumberStyleTypes["PKNumberStylePercent"] = "PKNumberStylePercent";
  PkpassNumberStyleTypes["PKNumberStyleScientific"] = "PKNumberStyleScientific";
  PkpassNumberStyleTypes["PKNumberStyleSpellOut"] = "PKNumberStyleSpellOut";
})(PkpassNumberStyleTypes || (exports.PkpassNumberStyleTypes = PkpassNumberStyleTypes = {}));

var ImageTypes;
exports.ImageTypes = ImageTypes;

(function (ImageTypes) {
  ImageTypes["background"] = "background";
  ImageTypes["footer"] = "footer";
  ImageTypes["icon"] = "icon";
  ImageTypes["logo"] = "logo";
  ImageTypes["strip"] = "strip";
  ImageTypes["thumbnail"] = "thumbnail";
})(ImageTypes || (exports.ImageTypes = ImageTypes = {}));

var imageTypes = [ImageTypes.background, ImageTypes.footer, ImageTypes.icon, ImageTypes.logo, ImageTypes.strip, ImageTypes.thumbnail];
exports.imageTypes = imageTypes;
//# sourceMappingURL=pkpass.js.map